import axios, { AxiosError, AxiosResponse } from "axios";

import { PageAlert } from "@/App/components";

const service = async function (options: {}, server?: string): Promise<{}> {
  const { showPageAlert } = PageAlert;

  /**
   * Since we are unable to use the hook inside the function,
   * we manually check to see if the user successfully logged
   * in with the new STS login module.
   */
  const stsAuthToken: string | null = localStorage.getItem("_auth");

  //  Create an Axios Client with default or IAM URL
  let URL = site.baseUrl;
  if (server && server === "IAM") URL = site.iamBaseUrl;
  if (server && server === "APPADMIN") URL = site.appAdminBaseUrl;
  const client = axios.create({
    baseURL: URL,
    headers: {
      "X-Referrer-Url": window.location.href,
    },
  });

  if (stsAuthToken && server !== "S3") {
    client.defaults.headers.common = {
      Authorization: `Bearer ${stsAuthToken}`,
    };
  }

  const onSuccess = function (response: AxiosResponse): {} {
    return response.data;
  };

  const onError = function (error: AxiosError): Promise<string> {
    let errorResult: object | string = error;

    if (error.response) {
      // Request was made but server responded with something other than 2xx
      errorResult = error.response;
    } else if (error.message) {
      // Something else happened while setting up the request triggered the error
      errorResult = error.message;
    } else if (typeof error === "string") {
      errorResult = {
        data: { message: error },
      };
    } else {
      errorResult = {
        data: { message: "Unknown error type." },
      };
    }

    showPageAlert({ show: true, type: "error", message: errorResult });
    return Promise.reject(errorResult);
  };

  return client(options).then(onSuccess).catch(onError);
};

export default service;
